module.exports = __webpack_public_path__ + "img/coupon1.e0a4cdcd.png";